<HiddenFromSSR>
  <footer>
    {@html "<p> Orbitalfore is <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/orbitalmartian8/orbitfore\">open-source software</a> distributed under the <a rel=\"noopener\" target=\"_blank\" href=\"https://raw.githubusercontent.com/orbitalmartian8/orbitfore/refs/heads/main/LICENSE\">AGPL License</a>. Here is the <a href=\"/settings/about#privacy-policy\" rel=\"prefetch\">privacy policy</a>. </p>"}
  </footer>
</HiddenFromSSR>
<script>
  import HiddenFromSSR from './HiddenFromSSR.html'

  export default {
    components: {
      HiddenFromSSR
    }
  }
</script>
